module.exports = __webpack_public_path__ + "img/vie_mobile.3215b9ff.jpg";